const { wrapRootElement } = require("./wrapRootElement")

exports.wrapRootElement = wrapRootElement
